import React from 'react';
import { HERITAGE_ASSETS } from '@/lib/api';

/**
 * Big circular Heritage Apparel seal. Uses the official brand PNG so it
 * remains identical to the artwork on garments and marketing collateral.
 */
export const HeritageSeal = ({ size = 96, className = '' }) => (
  <img
    src={HERITAGE_ASSETS.logo}
    alt="Heritage Apparel"
    width={size}
    height={size}
    className={`inline-block object-contain ${className}`}
    style={{ width: size, height: size }}
    data-testid="heritage-seal"
  />
);

/**
 * Compact brand mark used in nav bars and small badges. Falls back to the
 * dahlia icon PNG when a very small size is requested so the wordmark stays
 * readable at every scale.
 */
export const DahliaMark = ({ size = 44, className = '' }) => {
  const src = size <= 26 ? HERITAGE_ASSETS.dahliaMark : HERITAGE_ASSETS.logo;
  return (
    <img
      src={src}
      alt="Heritage"
      width={size}
      height={size}
      className={`inline-block object-contain ${className}`}
      style={{ width: size, height: size }}
      data-testid="dahlia-mark"
    />
  );
};

export const HeritageWordmark = ({ className = '' }) => (
  <div className={`flex flex-col items-center leading-none ${className}`}>
    <span className="h-serif text-2xl md:text-3xl tracking-[0.28em]" style={{ color: 'var(--heritage-plum)' }}>HERITAGE</span>
    <span className="h-eyebrow mt-1">Apparel</span>
  </div>
);
